import { CancelToken } from "axios";
import { axiosInstance } from "./ServiceConstants";
import { IRiderDetail, IRiderExtended, IRiderRead } from "../models/IRider";
class RiderService {
  async getRiderDetail(eventId: string, tagId: string): Promise<IRiderDetail> {
    let riderResponse = await axiosInstance.get<IRiderDetail>(
      `api/rider/${eventId}/${tagId}`
    );
    return riderResponse.data;
  }

  async getRiderRefresh(
    eventId: string,
    tagId: string
  ): Promise<IRiderExtended> {
    let riderRefresh = await axiosInstance.get<IRiderExtended>(
      `api/rider/${eventId}/${tagId}/refresh`
    );
    return riderRefresh.data;
  }

  async reorganizeRider(
    eventId: string,
    tagId: string,
    trial: boolean,
    group: string
  ): Promise<IRiderExtended> {
    let reorganizeResponse = await axiosInstance.put<IRiderExtended>(`api/rider/${eventId}/${tagId}/organize`, {
      raceId: eventId,
      tagId: tagId,
      trial: trial,
      group: group,
    });
    return reorganizeResponse.data;
  }

  async getRiderReads(
    raceId: string,
    tagId: string,
    cancelToken?: CancelToken
  ): Promise<IRiderRead[]> {
    const response = await axiosInstance.get<IRiderRead[]>(
      `api/rider/${raceId}/${tagId}/reads`,
      cancelToken ? { cancelToken } : undefined
    );
    return response.data;
  }

  async deleteRiderRead(
    raceId: string,
    epc: string,
    tagSeenTime: number
  ): Promise<void> {
    await axiosInstance.delete(
      `api/rider/${raceId}/${encodeURIComponent(epc)}/reads/${encodeURIComponent(String(tagSeenTime))}`
    );
  }

  async recalculateRiderLaps(raceId: string, tagId: string): Promise<void> {
    await axiosInstance.post(`api/Rider/${raceId}/${tagId}/recalculate-laps`);
  }
}

const RiderServiceInstance = new RiderService();

export default RiderServiceInstance;
